import { NavLink } from 'react-router-dom';
import React from 'react';

const TabLink = React.forwardRef((props, ref /* eslint-disable-line no-unused-vars */) => (
    <NavLink {...props} replace={true} />
));

export default TabLink;
